module.exports = __webpack_public_path__ + "static/media/99.e588be09.gif";